import { mastheadFacts } from "@/mocks/homeContent";

export default function Masthead() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-10 md:px-8 md:py-16">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-3xl">
            <p className="font-label text-[11px] uppercase tracking-[0.34em] text-secondary-600">
              The Exposure Reader · 读者观察报告
            </p>
            <h1 className="mt-5 font-heading text-5xl font-black leading-[0.95] tracking-tight text-foreground-950 md:text-7xl">
              黑料网站
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
              它到底靠不靠谱、好不好用？这一页不吹也不踩，只把打不开、审核慢、验证多、广告烦这些真实体验摆出来，让准备入坑的你提前避坑，也让正在被困扰的人看看别人是怎么解决这些问题的。
            </p>
          </div>

          <div className="flex shrink-0 flex-wrap gap-x-8 gap-y-3 lg:flex-col lg:items-end lg:gap-y-2 lg:text-right">
            {mastheadFacts.map((f) => (
              <div key={f.label} className="flex items-baseline gap-2 lg:flex-col lg:items-end lg:gap-0">
                <span className="text-[11px] tracking-widest text-foreground-500">{f.label}</span>
                <span className="font-heading text-sm text-foreground-900">{f.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}